/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:00:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { mapActions, mapGetters } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessages from '@/components/Login/LoginErrorMessages';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginCreatePasswordForm',

  components: {
    LoginErrorMessages, SmallLoadingSpinner,
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      newPassword: null,
      passwordRepeat: null,
      passwordHidden: true,
    };
  },

  beforeMount() {
    this.resetPasswords();
  },

  computed: {
    ...mapGetters(['authType']),
  },

  methods: {
    ...mapActions(['setPassword', 'undoLoginState', 'submitSetNewPassword']),
    async submitNewPassword() {
      const newPassword = this.newPassword;
      if (this.authType === 'createNewPasswordForRegisteredUser') {
        await this.submitSetNewPassword({ newPassword });
        this.$toaster.success('Hasło zostało zmienione');
      } else {
        await this.setPassword({ newPassword });
        this.$toaster.success('Hasło zostało zapisane. Możesz się teraz zalogować');
      }
    },
    togglePasswordVisiblity() {
      if (this.passwordHidden) {
        document.querySelector('.login-form__input--password').type = 'text';
        this.passwordHidden = false;
      } else {
        document.querySelector('.login-form__input--password').type = 'password';
        this.passwordHidden = true;
      }
    },
    resetPasswords() {
      this.newPassword = null;
      this.passwordRepeat = null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginCreatePasswordForm/component.js